import React from 'react'
import Image from "./linkedinIcon.png"
function LinkedinIcon() {
  return (
    <img src={Image} style={{width:"30px"}} alt='LinkedIN' />
  )
}

export default LinkedinIcon